import React from 'react';
import { ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function NYCAccountingHero() {
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-165">
        <a href="#/data/accounting" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-166">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-167" /> All accounting databases
        </a>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto text-center" data-id="element-168">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-100 text-blue-700 font-semibold text-sm mb-6" data-id="element-169">
            ✨ New York City local business data
          </div>

          <h1 className="font-bold tracking-tight text-slate-900 mb-8" data-id="element-170">
            <div className="text-5xl sm:text-6xl lg:text-7xl leading-[1.05] mb-4" data-id="element-171">
              New York City accounting database
            </div>
            <div className="text-3xl sm:text-4xl lg:text-5xl leading-tight text-blue-600" data-id="element-172">
              Owner contacts & email list
            </div>
          </h1>

          <p className="text-lg sm:text-xl text-slate-600 mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-173">
            Find and reach local accounting businesses across New York City. Get
            verified owner contacts, email lists, and phone numbers for 3,450+
            CPA firms, tax preparers, bookkeepers, forensic accountants, and
            CFOs across all five boroughs.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mb-10" data-id="element-174">
            {['CPA firms', 'Tax preparers', 'Bookkeepers', 'Forensic accountants', 'Audit specialists', 'CFO contacts'].map(tag => <span key={tag} className="px-3 py-1 bg-slate-100 text-slate-700 text-sm font-medium rounded-full" data-id="element-175">
                {tag}
              </span>)}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mb-10 justify-center" data-id="element-176">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center flex items-center justify-center gap-2" data-id="element-177">
              Try for free <ArrowRightIcon className="w-5 h-5" data-id="element-178" />
            </a>
          </div>

          {/* Stats Bar with Counter Animation */}
          <div className="flex flex-wrap gap-8 md:gap-12 pt-8 justify-center" data-id="element-179">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-180">
              <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-181">
                3,450+
              </div>
              <div className="text-sm text-slate-500 font-medium" data-id="element-182">
                NYC accounting firms
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} data-id="element-183">
              <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-184">97%</div>
              <div className="text-sm text-slate-500 font-medium" data-id="element-185">
                Verified accuracy
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.5
          }} data-id="element-186">
              <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-187">30+</div>
              <div className="text-sm text-slate-500 font-medium" data-id="element-188">
                Data points
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.5
          }} data-id="element-189">
              <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-190">
                Weekly
              </div>
              <div className="text-sm text-slate-500 font-medium" data-id="element-191">Updates</div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}